import React, { useEffect, useState } from 'react';
import { GetUsers, selectStateUsers, AddUser, setUsers, setCiudades, selectCiudades, selectSingleUser, setSingleUser } from '../../slice/usuarios.js';
import { useSelector, useDispatch } from 'react-redux';
import { AddUserApi, CallApiPost, CallApiGet } from '../../apicalls/calls.js';
import Adduser from './Adduser.jsx';
import FiltrosUsuarios from './FiltrosUsuarios.jsx';
import Paginate from '../Parts/Paginate.jsx';
import Percentages from './Percentages.jsx';


export default function Usuarios() {
    const AllUsers = useSelector(selectStateUsers);
    const Ciudades = useSelector(selectCiudades);
    const SingleU = useSelector(selectSingleUser);
    const [cooperativas,Setcooperativas]=useState([]);
    const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
    const dispatch = useDispatch();
    //Paginacion
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [pct, Setpct] = useState([]);
    const itemsPerPage = 10;


    useEffect(() => {
        fetchData();

    }, []);

    async function fetchData() {
        $("#backdrop").show();
        var params = { id_usuario: UsuarioS.user.id, tipo_usuario_log: UsuarioS.user.tipo_usuario }
        const Call = await CallApiGet('getAllUserByUser', params, UsuarioS.access_token);
        dispatch(setUsers(Call.success.users));
        dispatch(setCiudades(Call.success.ciudades));
        Setpct(Call.success.porcentajes);
        Setcooperativas(Call.success.cooperativas);
        //paginacion
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(Call.success.users.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(Call.success.users.length / itemsPerPage));
    }

    useEffect(() => {
        return (() => {
            $("#backdrop").hide();
        })
    }, [AllUsers]);

    //Funcion para añadir
    const AddUserForm = async (values, actions) => {
        //console.log("AddUser");
        var Val = { ...values };
        Val.usuario_creador = Val.usuario_creador == "" || Val.usuario_creador == null ? UsuarioS.user.id : Val.usuario_creador;
        const resp = await CallApiPost('AddUser', Val, UsuarioS.access_token);
        if (resp.status != 200) {
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: resp.error.message,
            });
        } else {
            fetchData();
            $("#addSorteo").modal("hide");
            actions.resetForm();
        }
    }

    const activeUser = async (id_user, accion) => {
        window.Swal.fire({
            title: '¿Está seguro de cambiar el estatus del usuario?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                $("#backdrop").show();
                var params = {
                    tipo: accion,
                    id_usuario: id_user
                };
                const resp = await CallApiPost('actionUsers', params, UsuarioS.access_token);
                if (resp.status != 200) {
                    window.Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: resp.error.message,
                    });
                    $("#backdrop").hide();
                } else {
                    await fetchData();
                    //dispatch(GetUsers(UsuarioS.access_token));
                    $("#backdrop").hide();
                }

            }
        })

    }

    const EditUser = async (id_user) => {
        $("#backdrop").show();
        const resp = await CallApiGet(`getInfoUser`, { id_usuario: id_user }, UsuarioS.access_token);
        //console.log('GetUser', resp);
        if (resp.status != 200) {
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: resp.error.message,
            });
        } else {
            //dispatch(setUsers(resp.success.users));
            dispatch(setSingleUser(resp.success.users))
            dispatch(setCiudades(resp.success.ciudades));
            //fetchData();
            //var sett={...resp.success.user};
            //sett.tipo_user_log=UsuarioS.user.tipo_usuario;
            //dispatch(setSingleUser(sett));
            //await fetchData();
            $('#addSorteo').modal('show');
            $("#backdrop").hide();
            //actions.resetForm();
        }
    }

    const OpenModal = () => {
        dispatch(setSingleUser({}));
        $('#addSorteo').modal('show');
    }

    const OpenPercentModal = () => {
        $('#percent').modal('show');
    }

    const Filter = async (values, actions) => {
        $("#backdrop").show();
        //var params = { id_usuario: UsuarioS.user.id }
        var params = { ...values };
        params.id_usuario = UsuarioS.user.id;
        params.tipo="Usuarios";
        //console.log(params);
        const Call = await CallApiGet('getAllUserByUser', params, UsuarioS.access_token);
        dispatch(setUsers(Call.success.users));
        dispatch(setCiudades(Call.success.ciudades));
        //Paginacion
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(Call.success.users.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(Call.success.users.length / itemsPerPage));
    }

    //Paginacion

    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;
        //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        setCurrentItems(AllUsers.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(AllUsers.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % AllUsers.length;
        setItemOffset(newOffset);
    };



    return (
        <div className="container-fluid">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Usuarios</h1>
                <div className="btn-group" role="group" aria-label="Basic example">
                    <a onClick={() => OpenPercentModal()}
                        className="d-sm-inline-block btn btn-sm shadow-sm text-white m-1" style={{ background: "#E6453B" }}>
                        <i className="fas fa-percent fa-sm text-white-50"></i> Porcentajes
                    </a>
                    <a onClick={() => OpenModal()}
                        className="d-sm-inline-block btn btn-sm shadow-sm text-white m-1" style={{ background: "#E6453B" }}>
                        <i className="fas fa-plus fa-sm text-white-50"></i> Nuevo Usuario
                    </a>
                </div>
            </div>
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold " style={{ color: "#E6453B" }}>Registros</h6>
                </div>
                <div className='card-body'>
                    <FiltrosUsuarios Filter={Filter} TipoU={UsuarioS.user.tipo_usuario} Cooperativas={cooperativas} />
                    <div className='table-responsive'>
                        <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Coperativa</th>
                                    <th>INE</th>
                                    <th>Tel</th>
                                    <th>Correo</th>
                                    <th>Tipo</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length == 0 && (
                                    <tr className='text-center'>
                                        <td colSpan={7}>No hay usuarios registrados.</td>
                                    </tr>
                                )}
                                {currentItems && currentItems.map((element, key) => {
                                    return element.tipo_usuario != 1 ? 
                                    <tr key={key}>
                                        <td>{element.nombre}</td>
                                        <td>{element.creadorN == '' ? 'N/A' : element.creadorN}</td>
                                        <td>{element.ine == '' ? 'N/A' : element.ine}</td>
                                        <td>{element.tel == '' ? 'N/A' : element.tel}</td>
                                        <td>{element.email}</td>
                                        <td>{element.nombre_tipo}</td>
                                        <td className="text-center">
                                            {element.activo == 1 ?
                                                <>
                                                    <button className="btn btn-success btn-circle btn-sm" onClick={() => EditUser(element.id, 1)} data-bs-toggle="tooltip" data-bs-placement="top" title="Editar usuario" ><i className="fa fa-file-signature"></i></button>
                                                    <button className="btn btn-danger btn-circle btn-sm" onClick={() => activeUser(element.id, 1)} data-bs-toggle="tooltip" data-bs-placement="top" title="Desactivar usuario" ><i className="fa fa-trash"></i></button>
                                                </> :
                                                <button className="btn btn-warning btn-circle btn-sm" onClick={() => activeUser(element.id, 2)} data-bs-toggle="tooltip" data-bs-placement="top" title="Activar usuario" ><i className="fa fa-exclamation-triangle"></i></button>}
                                        </td>
                                    </tr> : <></>
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className='float-md-right'>
                        <Paginate handlePageClick={handlePageClick} pageCount={pageCount} />
                    </div>
                </div>
            </div>
            <Adduser AddUser={AddUserForm} Ciudades={Ciudades} SingleU={SingleU} TipoUserLog={UsuarioS.user.tipo_usuario} Porcentaje={pct} />
            <Percentages TipoUserLog={UsuarioS.user.tipo_usuario} Porcentaje={pct} FetchData={fetchData} />
        </div>
    )
}
